import { render, staticRenderFns } from "./promotions-page.vue?vue&type=template&id=014d9438&"
import script from "./promotions-page.vue?vue&type=script&lang=js&"
export * from "./promotions-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports